import { GeneralThemeAndControls } from './types'
import { getTheme } from '@conexasaude/conexa-hero'

const theme = getTheme()

export const defaultThemeCnx: GeneralThemeAndControls = {
  theme: {
    desktop: {
      colors: theme.colors,
      typography: theme.typography,
      fonts: theme.fonts,
    },
    mobile: {
      colors: theme.colors,
      typography: theme.typography,
      fonts: theme.fonts,
    },
  },
  controls: {
    flagDesabilitarIlustracoes: false,
  },
}
